import useSWR from "swr";
import { authenticatedAxios, fetcher } from "lib/actions/fetcher";
import { endpointsSpeckle } from "components/modules/UploadDialog/lib/actions/endpointsSpeckle";
import { SpeckleAutomatedProject } from "components/modules/UploadDialog/SpeckleImportWizard/types/SpeckleAutomatedProject";
import { CreateSpeckleAutomatedProjectModel } from "components/modules/UploadDialog/SpeckleImportWizard/types/CreateSpeckleAutomatedProjectModel";
import { ToggleSpeckleAutomatedProjectModel } from "components/modules/UploadDialog/SpeckleImportWizard/types/ToggleSpeckleAutomatedProjectModel";

export function useSpeckleAutomatedProject(
  projectId: number,
  speckleConnectedAccountId: number,
  speckleProjectId: string,
) {
  const {
    data: automatedProject,
    isLoading,
    error,
    mutate,
  } = useSWR<SpeckleAutomatedProject>(
    endpointsSpeckle.getAutomation(
      projectId,
      speckleConnectedAccountId,
      speckleProjectId,
    ),
    fetcher,
  );

  function createSpeckleAutomatedProject(
    model: CreateSpeckleAutomatedProjectModel,
  ) {
    return authenticatedAxios
      .request({
        ...endpointsSpeckle.createAutomation,
        data: model,
      })
      .then((_) => {
        mutate();
      });
  }

  function toggleSpeckleAutomatedProject(
    model: ToggleSpeckleAutomatedProjectModel,
  ) {
    return authenticatedAxios
      .request({
        ...endpointsSpeckle.toggleAutomation,
        data: model,
      })
      .then((_) => {
        mutate();
      });
  }

  function isUserSpeckleProjectOwner(
    speckleConnectedAccountId: number,
    speckleProjectId: string,
  ): Promise<boolean> {
    return authenticatedAxios
      .get<boolean>(
        endpointsSpeckle.isUserProjectOwner(
          speckleConnectedAccountId,
          speckleProjectId,
        ),
      )
      .then((resp) => {
        return resp.status === 200;
      })
      .catch((error) => {
        console.error("Error retrieving user status", error);
        return false;
      });
  }

  return {
    automatedProject,
    isLoading,
    error,
    mutate,
    createSpeckleAutomatedProject,
    toggleSpeckleAutomatedProject,
    isUserSpeckleProjectOwner,
  };
}
